import React from "react";
import "./Payment_Method.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import No_data from "../Common/No_data/No_data";
function Payment_Method() {
  const navigate = useNavigate();
  return (
    <>
      <section className="Payment_Method">
        <Common_white_header headingText={"Payment Method"} />

        <div className="container">

           <No_data/>
          <div className="add-bank-section">
            <div
              className="plus-circle"
              onClick={() => navigate("/add-payment-method")}
            >
              <FaPlus />
            </div>

            <button
              className="btn_register_bg"
              onClick={() => navigate("/add-payment-method")}
            >
              Add Payment Method
            </button>
          </div>
        </div>
      </section>
    </>
  );
}

export default Payment_Method;
